// extracted by mini-css-extract-plugin
export default {"wiseOwlContainer":"wiseOwlViewV2_wiseOwlContainer__Iz3RM","paste-theme-provider":"wiseOwlViewV2_paste-theme-provider__vA6Fp"};